import type { IContextMutationResult } from '@modules/core/services/query/types';
import { useRestClient } from '@modules/core/services/api';
import { useContextMutation } from '@modules/core/services/query';
import {
  GROUPS_OF_ADMINS_DELETE_API_URL,
  GROUPS_OF_ADMINS_DELETE_MUTATION_KEY,
  GROUPS_OF_ADMINS_LIST_QUERY_KEY,
  GROUPS_OF_ADMINS_PERMISSIONS,
} from '@modules/groups-of-admins/constants';
import { useToastStore } from '@modules/toast/store';

export default function useGroupOfAdminsDeleteMutation(): IContextMutationResult<
  void,
  Error,
  number
> {
  const { fetchDelete } = useRestClient();
  const { displayPresetToast } = useToastStore();

  return useContextMutation<void, Error, number>({
    mutationKey: [GROUPS_OF_ADMINS_DELETE_MUTATION_KEY],
    mutationFn: (id) => fetchDelete<void>(
      GROUPS_OF_ADMINS_DELETE_API_URL,
      {
        permission: GROUPS_OF_ADMINS_PERMISSIONS.DELETE,
        urlParams: {
          id,
        },
      },
    ),
    async onSuccess({ queryClient }) {
      await queryClient.invalidateQueries({ queryKey: [GROUPS_OF_ADMINS_LIST_QUERY_KEY] });
      displayPresetToast('removed');
    },
  });
}
